var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m6.859 6.5 2.585-2.586c.39-.39.47-.944.177-1.237s-.847-.214-1.237.177L5.555 5.682c-.243.243-.365.55-.352.818-.014.267.109.574.352.817l2.829 2.829c.39.39.944.47 1.237.177s.214-.847-.177-1.238z",
  clipRule: "evenodd"
})));
export { SvgRight as ReactComponent };
export default __webpack_public_path__ + "static/media/right.741d8b046198db0e2bd8855132c04699.svg";